export type SubmitRequest = {
  company_name: string;
  company_domain: string;
};

export type SubmitSuccess = {
  status: "accepted";
  job_id: string;
};

export type SubmitError = {
  status: "error";
  message: string;
};

export type SubmitResponse = SubmitSuccess | SubmitError;

export type StatusInProgress = {
  job_id: string;
  status: "pending" | "researching" | "analysis_complete";
  company_name: string;
};

export type StatusComplete = {
  job_id: string;
  status: "complete";
  company_name: string;
  report_url: string;
};

export type StatusErrorShape = {
  status: "error";
  message: string;
};

export type StatusResponse = StatusInProgress | StatusComplete | StatusErrorShape;

export class ApiError extends Error {
  status?: number;
  constructor(message: string, status?: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}
